// import React from 'react';
// import { Typography, Box } from '@mui/material';
// import './Footer.css';

// const Footer = () => {
//   return (
//     <Box className="footer-container">
//       <Box className="divider" />
//       <Typography variant="body2" className="copyright">
//         © Copyright 2018 - 2025 | 
//       </Typography>
//       <Box className="footer-links">
//         <Typography variant="body2" component="a" href="#" className="footer-link">
//           Terms & Conditions
//         </Typography>
//         <Typography variant="body2" component="a" href="#" className="footer-link">
//           Privacy Policy
//         </Typography>
//         <Typography variant="body2" component="a" href="#" className="footer-link">
//           Cancellation & Refund Policy
//         </Typography>
//       </Box>
//       <Typography variant="body2" className="tech-support">
//         Tech Support Email : 
//       </Typography>
//     </Box>
//   );
// };

// export default Footer;

import React from 'react';
import { Typography, Box, Link } from '@mui/material';
import './Footer.css';

const Footer = () => {
  return (
    <Box className="footer-container">
      <Box className="footer-divider" />
      
      <Box className="footer-content">
        <Typography variant="body2" className="copyright">
          © 2024 Hithlaksh Software Solutions. All rights reserved.
        </Typography>

        <Box className="footer-links">
          <Link href="#" className="footer-link">Terms & Conditions</Link>
          <Link href="#" className="footer-link">Privacy Policy</Link>
          <Link href="#" className="footer-link">Cancellation & Refund Policy</Link>
        </Box>

        <Typography variant="body2" className="tech-support">
          Tech Support: services@hithlakshsolutions.com| +91-7795791587
        </Typography>

        <Typography variant="body2" className="powered-by">
          Powered by <strong>HLS</strong>
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
